export const MODULE_NAME = 'UNIT_TYPE_MODULE';
